import { tenantSelector } from '@/features/configuration/configurationSelector';
import { useTranslation } from '@/i18n';
import type { TransTextKeys } from '@/i18n/trans/text';
import { useSelector } from '@/store/utils';
import { useEffect } from 'react';

export const usePageTitle = (transKey: TransTextKeys) => {
  const { t, ready } = useTranslation();
  const tenant = useSelector(tenantSelector);

  useEffect(() => {
    if (!ready) {
      return;
    }

    document.title = `${tenant.value.charAt(0).toUpperCase() + tenant.value.slice(1)} | ${t(`text.${transKey}`)}`;
  }, [t, ready, tenant, transKey]);
};
